/**************************************************
 * Nombre:       Formulario_Usuario_Padres
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, IconButton, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined, Delete,
    Flag,
    FlagOutlined,
    Google,
    MilitaryTechOutlined, Person,
    PhoneAndroid,
    QrCode2Outlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSCUENTA} from "../../Constantes";
import {PAISESINDICATIVO} from "../../Modulo_formularios/Recursos/indicativos";
import {useEffect, useState} from "react";
import {idACorreo} from "../../CodNegocio/Funciones/idACorreo";

const Formulario_Usuario_Padres = ({...props}) => {
    const [respuestas, setRespuestass] = useState([]);

    const agregar = () => {
        let opcion = props.props.getValues('opcion');
        let opciones = props.props.getValues('padres');
        if (opcion) {
            let arr = []
            if (opciones) {
                arr = opciones
            }
            arr.push(opcion);
            props.props.setValue('opcion', '')
            props.props.setValue('padres', arr)
        }
    }

    const borrar = (index) => {

        let opciones = props.props.getValues('padres');
        let arr = opciones
        arr.splice(index, 1);
        props.props.setValue('padres', arr)

    }



    useEffect(() => {

        let ops = props.props.getValues('padres');
        if (ops && ops.length > 0) {

            let arr = []
            for (let i = 0; i < ops.length; i++) {
                let opcion = ops[i]
                arr.push(idACorreo(opcion));
            }

            setRespuestass(arr);
        }


    }, [props.props.watch('padres')])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >



                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Google} nombre={'Correo de Google'} dato={'correo'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1}}>
                    <Typography>Padres</Typography>
                </Grid>

                <Grid container size={9} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={Person} nombre={'Padre'} dato={'opcion'} {...props}

                    />
                </Grid>

                <Grid container size={3} sx={{justifyContent: 'flex-start'}}>
                    <Button
                        onClick={() => agregar()}
                    >Agregar</Button>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    {respuestas.map((it, index) => {
                        return (

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={10}
                                      sx={{justifyContent: 'flex-start', borderBottom: 1, py: 1}}>
                                    <Typography><span style={{paddingRight: 5}}>{index + 1}.</span>{it}</Typography>
                                </Grid>

                                <Grid container size={2} sx={{justifyContent: 'flex-end'}}>
                                    <IconButton
                                        onClick={() => borrar(index)}
                                    >
                                        <Delete/>
                                    </IconButton>
                                </Grid>

                            </Grid>

                        )
                    })}

                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Usuario_Padres